import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Flex,
  Loader,
  Radio,
  RadioGroupField,
  TextField,
  Text,
  PasswordField,
  View,
  Icon,
  Alert,
  Card,
  Link
} from "@aws-amplify/ui-react";
import "./Clienti.css";
import { checkClienteAPI, checkClienteNomeCognomeAPI, checkClienteTelefonoAPI, createClienteAPI, createUserAPI } from "../../data/api";
import ClienteForm from "./ClienteForm";
import { NavLink, useNavigate } from "react-router-dom";
import { MdArrowBack, MdArrowForward, MdArrowRightAlt, MdCancel } from "react-icons/md";
import { endOfToday } from "date-fns";
import { formConfig } from "./config";
import ReferenteForm from "./ReferenteForm";

const defaultForm = {
  Nome: "",
  Cognome: "",
  Telefono: "+39",
  Referenti: []
};

const CreateClienteForm = (props) => {
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [errorCreate, setErrorCreate] = useState(false);
  const navigate = useNavigate();
  const modifyReferentiRef = useRef(null);

  // create Cliente form data
  const [createClienteFormValues, setCreateClienteFormValues] = useState(() => {
    const storage = localStorage.getItem('createClienteFormValues');
    return storage ? JSON.parse(storage) : defaultForm;
  });

  const changeInputCreateClienteForm = (e) => {
    const { name, value } = e.target;
    const newValue = { ...createClienteFormValues };
    name.split('.').reduce((acc, key, idx, arr) => 
      acc[key] = idx === arr.length - 1 ? value : acc[key] || {}, newValue);
    setCreateClienteFormValues(newValue);
    localStorage.setItem('createClienteFormValues', JSON.stringify(newValue));
  };

  const changeInputReferenti = (e, index) => {
    const { name, value } = e.target;
    const newValue = { ...createClienteFormValues.Referenti[index] };
    name.split('.').reduce((acc, key, idx, arr) => 
      acc[key] = idx === arr.length - 1 ? value : acc[key] || {}, newValue);

    const newReferenti = [...createClienteFormValues.Referenti];
    newReferenti[index] = newValue;
    const newFormValue = {...createClienteFormValues, Referenti: newReferenti}
    setCreateClienteFormValues(newFormValue);
    localStorage.setItem('createClienteFormValues', JSON.stringify(newFormValue));
  };

  const resetCreateClienteForm = () => {
    setCreateClienteFormValues(defaultForm);
    localStorage.setItem('createClienteFormValues', JSON.stringify(defaultForm));
  }

  const createCliente = async () => {
    try{
      setLoadingCreate(true);
      setErrorCreate(false);
      const response = await createClienteAPI(createClienteFormValues);
      const idCliente = response.cliente_id ?? ''
      setLoadingCreate(false);
      if(idCliente !== ''){
        navigate('/clienti/detail?id='+idCliente)
      } else {
        navigate('/clienti')
      }
      resetCreateClienteForm();
    } catch (e) {
      console.log('Create Cliente failed ', e);
      setErrorCreate(true);
      setLoadingCreate(false);
    }
  };

  // check if duplicate
  const [showAlertDuplicate, setShowAlertDuplicate] = useState(false);
  const checkClienteDuplicato = async () => {
    const nome = createClienteFormValues['Nome'];
    const cognome = createClienteFormValues['Cognome'];
    const telefono = createClienteFormValues['Telefono'];
    if(nome !== '' && cognome !== '' && telefono !== '' && nome !== null && cognome !== null && telefono !== null){
      try{
        const check = await checkClienteAPI(nome, cognome, telefono);
        if(check.exists){
          setShowAlertDuplicate(true);
        } else {
          setShowAlertDuplicate(false);
        }
      } catch (e) {
        console.log('Check cliente failed ', e);
        setShowAlertDuplicate(false);
      }
    } else {
      setShowAlertDuplicate(false);
    }
  }

  // check if nome cognome is duplicate
  const [showAlertNomeCognomeDuplicate, setShowAlertNomeCognomeDuplicate] = useState(false);
  const checkClienteNomeCognomeDuplicato = async () => {
    const nome = createClienteFormValues['Nome'];
    const cognome = createClienteFormValues['Cognome'];
    if(nome !== '' && cognome !== '' && nome !== null && cognome !== null) {
      try{
        const check = await checkClienteNomeCognomeAPI(nome, cognome);
        if(check.exists){
          setShowAlertNomeCognomeDuplicate(true);
        } else {
          setShowAlertNomeCognomeDuplicate(false);
        }
      } catch (e) {
        console.log('Check Cliente nome cognome failed ', e);
        setShowAlertNomeCognomeDuplicate(false);
      }
    } else {
      setShowAlertNomeCognomeDuplicate(false);
    }
  }

  const [showAlertTelefonoDuplicate, setShowAlertTelefonoDuplicate] = useState(false);
  const checkClienteTelefonoDuplicato = async () => {
    const telefono = createClienteFormValues['Telefono'];
    if(telefono !== '' && telefono !== null) {
      try{
        const check = await checkClienteTelefonoAPI(telefono);
        if(check.exists){
          setShowAlertTelefonoDuplicate(true);
        } else {
          setShowAlertTelefonoDuplicate(false);
        }
      } catch (e) {
        console.log('Check Cliente telefono failed ', e);
        setShowAlertTelefonoDuplicate(false);
      }
    } else {
      setShowAlertTelefonoDuplicate(false);
    }
  }

  const onBlurField = (e) => {
    if(e.target.name === 'Nome' || e.target.name === 'Cognome' || e.target.name === 'Telefono'){
      checkClienteDuplicato()
    }
    if(e.target.name === 'Nome' || e.target.name === 'Cognome'){
      checkClienteNomeCognomeDuplicato()
    }
    if(e.target.name === 'Telefono'){
      checkClienteTelefonoDuplicato()
    }
  }

  useEffect(() => {
    checkClienteDuplicato()
    checkClienteNomeCognomeDuplicato()
    checkClienteTelefonoDuplicato()
  }, []);

  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);
  useEffect(() => {
    const isAnyFieldEmpty = formConfig.sections
      .flatMap(section => section.fields)
      .filter(field => (field.isRequired ?? false))
      .map(field => field.name)
      .some(field => !createClienteFormValues[field] 
        || createClienteFormValues[field] === '' 
        || JSON.stringify(createClienteFormValues[field]) === '{}');
      setIsSaveButtonDisabled(isAnyFieldEmpty);
  }, [createClienteFormValues]);

  return (
    <View maxWidth="100%" padding="0rem" minHeight="100vh">
      <View
        backgroundColor="var(--amplify-colors-white)"
        borderRadius="6px"
        maxWidth="100%"
        padding="1rem"
      >
        <View marginBottom="10px">
            <NavLink to='/clienti' className="amplify-link"><Icon as={MdArrowBack}></Icon> Torna indietro</NavLink>
        </View>
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px'
        }}>
            <h2>Nuovo cliente</h2>
            <View >
              <Button
                onClick={() => createCliente()}
                variation="primary"
                disabled={loadingCreate || isSaveButtonDisabled || showAlertDuplicate || ((createClienteFormValues.Disabilita === 'Si') && (!(createClienteFormValues.Documenti?.find(d => d.Tipo === '104') !== undefined)))}
                width={"fit-content"}
                alignSelf={"right"}
              >
                {loadingCreate ? <Loader/> : "Salva nuovo cliente"}
              </Button>
              { errorCreate ? <View><span style={{color: "red", marginLeft: "auto"}}>Errore nella creazione!</span></View> : ""}
            </View>
        </div>
        <Flex as="form" direction="column">
            {showAlertDuplicate && <Alert variation="error">Attenzione: esiste già un cliente con questa anagrafica di base. Controllare la presenza di eventuali duplicati già inseriti.</Alert>}
            {(createClienteFormValues.Disabilita === 'Si') && (!(createClienteFormValues.Documenti?.find(d => d.Tipo === '104') !== undefined)) && <Alert variation="error">Attenzione: in caso di cliente con disabilità, è necessario inserire i documenti per la 104.</Alert>}
            <Alert variation="warning">Attenzione: il cliente non è stato ancora salvato in anagrafica.</Alert>
            {showAlertNomeCognomeDuplicate && !showAlertDuplicate && <Alert variation="warning">Attenzione: esiste già un cliente con lo stesso nome e cognome. Controllare la presenza di eventuali duplicati già inseriti.</Alert>}
            {showAlertTelefonoDuplicate && !showAlertDuplicate && <Alert variation="warning">Attenzione: esiste già un cliente con lo stesso numero di telefono. Controllare la presenza di eventuali duplicati già inseriti.</Alert>}
            <Link
                onClick={() => modifyReferentiRef?.current?.scrollIntoView({ behavior: "smooth" })}
              >Vai ai referenti <Icon as={MdArrowForward}></Icon></Link>
            <ClienteForm
                value={createClienteFormValues}
                savedValue={createClienteFormValues}
                onChange={changeInputCreateClienteForm}
                onBlur={onBlurField}>
            </ClienteForm>
            <hr/>
            <View ref={modifyReferentiRef}><h2>Inserisci referenti</h2></View>
            {
                  (createClienteFormValues.Referenti)?.map((r, index) => {
                    return <Card variation="elevated" marginBottom="20px">
                    <View columnSpan={[1,1,1,4]} textAlign="right">
                      <Icon 
                        as={MdCancel} 
                        color="red" 
                        marginLeft="5px" 
                        marginBottom="2px" 
                        style={{cursor: "pointer"}}  
                        onClick={ () => changeInputCreateClienteForm({target: {name: 'Referenti', value: 
                          (createClienteFormValues['Referenti'] ?? []).filter((r, i) => index !== i)
                        }}) }
                      />
                    </View>
                      <View columnSpan={[1,1,1,4]}>
                        <Text marginBottom="5px"><h4>Referente #{index+1}</h4></Text>
                      </View>
                      <ReferenteForm
                        className={"Referenti-"+index}
                        value={createClienteFormValues.Referenti?.[index] ?? defaultForm}
                        savedValue={createClienteFormValues.Referenti?.[index] ?? defaultForm}
                        onChange={(e) => changeInputReferenti(e, index)}
                        onBlur={onBlurField}>
                      </ReferenteForm>
                    </Card>
                    }
                  )
                }
                <Button 
                  className="add-Referenti"
                  onClick={ () => changeInputCreateClienteForm({target: {name: 'Referenti', value: [...(createClienteFormValues['Referenti'] ?? []), {}]}}) }
                  width={"fit-content"}
                >Aggiungi referente</Button>
            <View textAlign={"right"}>
              <Button
                onClick={() => createCliente()}
                variation="primary"
                disabled={loadingCreate || isSaveButtonDisabled || showAlertDuplicate || ((createClienteFormValues.Disabilita === 'Si') && (!(createClienteFormValues.Documenti?.find(d => d.Tipo === '104') !== undefined)))}
                width={"fit-content"}
                alignSelf={"right"}
              >
                {loadingCreate ? <Loader/> : "Salva nuovo cliente"}
              </Button>
            </View>
        { errorCreate ? <span style={{color: "red", marginLeft: "auto"}}>Errore nella creazione!</span> : ""}
        </Flex>
      </View>
    </View>
  );
};

export default CreateClienteForm;
